import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useParams } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import axiosInstance from '../../../../services/AxiosInstance';
import { getApiUrl } from '../../../../utils/ApiUtils';

const ExpenseChart = () => {
    const { companyId } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedPeriod, setSelectedPeriod] = useState('this_year');
    const [chartData, setChartData] = useState({
        series: [],
        options: {
            chart: {
                type: 'donut',
                height: 350,
                background: 'transparent',
                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
            },
            labels: [],
            colors: ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4', '#84cc16', '#f97316'],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }],
            legend: {
                position: 'bottom',
                fontSize: '0.75rem',
                fontWeight: 500,
                labels: {
                    colors: '#374151'
                },
                markers: {
                    width: 12,
                    height: 12,
                    radius: 6
                }
            },
            tooltip: {
                theme: 'light',
                style: {
                    fontSize: '0.75rem'
                },
                y: {
                    formatter: function (val, { seriesIndex, w }) {
                        const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                        const percentage = ((val / total) * 100).toFixed(1);
                        return `${new Intl.NumberFormat('sv-SE', {
                            style: 'currency',
                            currency: 'SEK',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        }).format(val)} (${percentage}%)`;
                    }
                }
            },
            plotOptions: {
                pie: {
                    donut: {
                        size: '70%',
                        labels: {
                            show: true,
                            name: {
                                show: true,
                                fontSize: '0.875rem',
                                fontWeight: 600,
                                color: '#374151'
                            },
                            value: {
                                show: true,
                                fontSize: '1.5rem', // Increased size for better visibility
                                fontWeight: 700,
                                color: '#1e293b',
                                formatter: function (val) {
                                    // Show percentage by default
                                    return val + '%';
                                }
                            },
                            total: {
                                show: true,
                                showAlways: false, // Only show when not hovering
                                label: 'Totalt',
                                fontSize: '0.875rem',
                                fontWeight: 600,
                                color: '#64748b',
                                formatter: function (w) {
                                    // Show total percentage
                                    return '100%';
                                }
                            }
                        }
                    }
                }
            },
            stroke: {
                width: 0
            },
            dataLabels: {
                enabled: false
            },
            noData: {
                text: 'Laddar data...',
                align: 'center',
                verticalAlign: 'middle',
                style: {
                    color: '#64748b',
                    fontSize: '14px'
                }
            }
        }
    });

    const periodOptions = [
        { value: 'this_month', label: 'Denna månad' },
        { value: 'last_3_months', label: 'Senaste 3 månaderna' },
        { value: 'last_6_months', label: 'Senaste 6 månaderna' },
        { value: 'this_year', label: 'Detta år' },
        { value: 'last_12_months', label: 'Senaste 12 månaderna' },
        { value: 'last_year', label: 'Förra året' }
    ];

    useEffect(() => {
        fetchExpenseData();
    }, [companyId, selectedPeriod]);

    // const fetchExpenseData = async () => {
    //     try {
    //         setLoading(true);
    //         setError(null);

    //         const response = await axiosInstance.get(
    //             getApiUrl(`${companyId}/dashboard/expense-chart`),
    //             {
    //                 params: { period: selectedPeriod },
    //                 withCredentials: true
    //             }
    //         );

    //         const { categories, amounts } = response.data;

    //         // Calculate total and percentages
    //         const total = amounts.reduce((sum, amount) => sum + amount, 0);
    //         const percentages = amounts.map(amount =>
    //             total > 0 ? ((amount / total) * 100).toFixed(1) : 0
    //         );

    //         setChartData(prevData => ({
    //             ...prevData,
    //             series: percentages.map(p => parseFloat(p)), // Use percentages for the series
    //             options: {
    //                 ...prevData.options,
    //                 labels: categories,
    //                 // Store original amounts for tooltip
    //                 chart: {
    //                     ...prevData.options.chart,
    //                     events: {
    //                         dataPointSelection: function (event, chartContext, config) {
    //                             // Optional: handle click events
    //                         }
    //                     }
    //                 },
    //                 // Add custom data for tooltips
    //                 plotOptions: {
    //                     ...prevData.options.plotOptions,
    //                     pie: {
    //                         ...prevData.options.plotOptions.pie,
    //                         customScale: 1,
    //                         // Store original amounts in a custom property
    //                         dataLabels: {
    //                             enabled: false
    //                         }
    //                     }
    //                 },
    //                 // Update tooltip to use original amounts
    //                 tooltip: {
    //                     theme: 'light',
    //                     style: {
    //                         fontSize: '0.75rem'
    //                     },
    //                     y: {
    //                         formatter: function (val, { seriesIndex, w }) {
    //                             // Get original amount from the amounts array
    //                             const originalAmount = amounts[seriesIndex];
    //                             return `${new Intl.NumberFormat('sv-SE', {
    //                                 style: 'currency',
    //                                 currency: 'SEK',
    //                                 minimumFractionDigits: 0,
    //                                 maximumFractionDigits: 0
    //                             }).format(originalAmount)} (${val}%)`;
    //                         }
    //                     }
    //                 }
    //             }
    //         }));

    //     } catch (error) {
    //         console.error('Error fetching expense data:', error);
    //         setError('Kunde inte ladda kostnadsdata');
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // Update the fetchExpenseData function:

    const fetchExpenseData = async () => {
        try {
            setLoading(true);
            setError(null);

            const response = await axiosInstance.get(
                getApiUrl(`${companyId}/dashboard/expense-chart`),
                {
                    params: { period: selectedPeriod },
                    withCredentials: true
                }
            );

            const { categories, amounts, detailedBreakdown } = response.data;

            // Calculate total and percentages
            const total = amounts.reduce((sum, amount) => sum + amount, 0);
            const percentages = amounts.map(amount =>
                total > 0 ? ((amount / total) * 100).toFixed(1) : 0
            );

            setChartData(prevData => ({
                ...prevData,
                series: percentages.map(p => parseFloat(p)),
                options: {
                    ...prevData.options,
                    labels: categories,
                    // Enhanced tooltip with detailed breakdown
                    tooltip: {
                        theme: 'light',
                        style: {
                            fontSize: '0.75rem'
                        },
                        custom: function ({ seriesIndex, w }) {
                            const category = categories[seriesIndex];
                            const originalAmount = amounts[seriesIndex];
                            const percentage = percentages[seriesIndex];
                            const details = detailedBreakdown[category];

                            const formatCurrency = (val) => {
                                return new Intl.NumberFormat('sv-SE', {
                                    style: 'currency',
                                    currency: 'SEK',
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0
                                }).format(val);
                            };

                            // Build detailed breakdown HTML
                            let detailsHtml = '';
                            if (details && details.accounts && details.accounts.length > 0) {
                                // Show top 5 accounts, or all if 5 or fewer
                                const accountsToShow = details.accounts.slice(0, 5);
                                const remainingCount = details.accounts.length - 5;

                                detailsHtml = accountsToShow.map(account => `
                                <div style="
                                    display: flex; 
                                    justify-content: space-between; 
                                    align-items: center;
                                    padding: 4px 0;
                                    border-bottom: 1px solid #f1f5f9;
                                    font-size: 0.75rem;
                                ">
                                    <div style="flex: 1;">
                                        <div style="font-weight: 500; color: #374151;">
                                            ${account.accountNumber}
                                        </div>
                                        <div style="color: #64748b; font-size: 0.7rem;">
                                            ${account.accountName}
                                        </div>
                                    </div>
                                    <div style="
                                        font-weight: 600; 
                                        color: #1e293b;
                                        margin-left: 8px;
                                        font-size: 0.75rem;
                                    ">
                                        ${formatCurrency(account.amount)}
                                    </div>
                                </div>
                            `).join('');

                                if (remainingCount > 0) {
                                    detailsHtml += `
                                    <div style="
                                        padding: 6px 0;
                                        text-align: center;
                                        color: #64748b;
                                        font-size: 0.7rem;
                                        font-style: italic;
                                    ">
                                        +${remainingCount} fler konton
                                    </div>
                                `;
                                }
                            }

                            return `
                            <div style="
                                background: white; 
                                padding: 16px; 
                                border-radius: 12px; 
                                box-shadow: 0 8px 24px rgba(0,0,0,0.15);
                                border: 1px solid #e2e8f0;
                                font-family: system-ui, sans-serif;
                                min-width: 280px;
                                max-width: 350px;
                            ">
                                <div style="
                                    font-weight: 700; 
                                    margin-bottom: 12px; 
                                    color: #1e293b;
                                    font-size: 0.9rem;
                                    border-bottom: 2px solid #f1f5f9;
                                    padding-bottom: 8px;
                                ">
                                    ${category}
                                </div>
                                
                                <div style="
                                    display: flex; 
                                    justify-content: space-between; 
                                    align-items: center;
                                    margin-bottom: 12px;
                                    padding: 8px;
                                    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
                                    border-radius: 8px;
                                ">
                                    <span style="
                                        color: #64748b; 
                                        font-size: 0.8rem; 
                                        font-weight: 500;
                                    ">
                                        Total:
                                    </span>
                                    <span style="
                                        font-weight: 700; 
                                        color: #1e293b; 
                                        font-size: 0.9rem;
                                    ">
                                        ${formatCurrency(originalAmount)} (${percentage}%)
                                    </span>
                                </div>

                                ${detailsHtml ? `
                                    <div style="margin-top: 12px;">
                                        <div style="
                                            font-size: 0.75rem; 
                                            font-weight: 600; 
                                            color: #64748b; 
                                            margin-bottom: 8px;
                                        ">
                                            Fördelning per konto:
                                        </div>
                                        ${detailsHtml}
                                    </div>
                                ` : ''}
                            </div>
                        `;
                        }
                    },
                    // Enhanced plotOptions for better hover experience
                    plotOptions: {
                        pie: {
                            donut: {
                                size: '70%',
                                labels: {
                                    show: true,
                                    name: {
                                        show: true,
                                        fontSize: '0.875rem',
                                        fontWeight: 600,
                                        color: '#374151'
                                    },
                                    value: {
                                        show: true,
                                        fontSize: '1.5rem',
                                        fontWeight: 700,
                                        color: '#1e293b',
                                        formatter: function (val) {
                                            return val + '%';
                                        }
                                    },
                                    total: {
                                        show: true,
                                        showAlways: false,
                                        label: 'Totalt',
                                        fontSize: '0.875rem',
                                        fontWeight: 600,
                                        color: '#64748b',
                                        formatter: function (w) {
                                            return '100%';
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }));

        } catch (error) {
            console.error('Error fetching expense data:', error);
            setError('Kunde inte ladda kostnadsdata');
        } finally {
            setLoading(false);
        }
    };

    const handlePeriodChange = (period) => {
        setSelectedPeriod(period);
    };

    const getSelectedPeriodLabel = () => {
        const selected = periodOptions.find(option => option.value === selectedPeriod);
        return selected ? selected.label : 'Detta år';
    };

    if (error) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '350px',
                background: 'transparent'
            }}>
                <div style={{
                    textAlign: 'center',
                    color: '#64748b'
                }}>
                    <p>{error}</p>
                    <button
                        onClick={fetchExpenseData}
                        style={{
                            padding: '0.5rem 1rem',
                            border: '1px solid #e2e8f0',
                            borderRadius: '8px',
                            background: 'white',
                            color: '#374151',
                            cursor: 'pointer'
                        }}
                    >
                        Försök igen
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div style={{ background: 'transparent' }}>
            {/* Period Selection Dropdown */}
            <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginBottom: '1rem'
            }}>
                <Dropdown>
                    <Dropdown.Toggle
                        variant="outline-secondary"
                        size="sm"
                        style={{
                            borderRadius: '8px',
                            border: '1px solid #e2e8f0',
                            color: '#64748b',
                            fontSize: '0.875rem'
                        }}
                    >
                        {getSelectedPeriodLabel()}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {periodOptions.map(option => (
                            <Dropdown.Item
                                key={option.value}
                                onClick={() => handlePeriodChange(option.value)}
                                active={selectedPeriod === option.value}
                            >
                                {option.label}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </div>

            {/* Loading state */}
            {loading && (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '350px'
                }}>
                    <div>Laddar...</div>
                </div>
            )}

            {/* Chart */}
            {!loading && (
                <ReactApexChart
                    options={chartData.options}
                    series={chartData.series}
                    type="donut"
                    height={350}
                />
            )}
        </div>
    );
};

export default ExpenseChart;





// import React, { useState, useEffect } from 'react';
// import ReactApexChart from 'react-apexcharts';
// import { useParams } from 'react-router-dom';
// import axiosInstance from '../../../../services/AxiosInstance';
// import { getApiUrl } from '../../../../utils/ApiUtils';

// const ExpenseChart = () => {
//     const { companyId } = useParams();
//     const [chartData, setChartData] = useState({
//         series: [44, 25, 15, 10, 6],
//         options: {
//             chart: {
//                 type: 'donut',
//                 background: 'transparent',
//                 fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
//             },
//             labels: ['Löner', 'Hyra & Lokaler', 'Material', 'Marknadsföring', 'Övrigt'],
//             colors: ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6'],
//             responsive: [{
//                 breakpoint: 480,
//                 options: {
//                     chart: {
//                         width: 200
//                     },
//                     legend: {
//                         position: 'bottom'
//                     }
//                 }
//             }],
//             legend: {
//                 position: 'bottom',
//                 fontSize: '0.75rem',
//                 fontWeight: 500,
//                 labels: {
//                     colors: '#374151'
//                 },
//                 markers: {
//                     width: 12,
//                     height: 12,
//                     radius: 6
//                 }
//             },
//             tooltip: {
//                 theme: 'light',
//                 style: {
//                     fontSize: '0.75rem'
//                 },
//                 y: {
//                     formatter: function (val) {
//                         return val + '%';
//                     }
//                 }
//             },
//             plotOptions: {
//                 pie: {
//                     donut: {
//                         size: '70%',
//                         labels: {
//                             show: true,
//                             name: {
//                                 show: true,
//                                 fontSize: '0.875rem',
//                                 fontWeight: 600,
//                                 color: '#374151'
//                             },
//                             value: {
//                                 show: true,
//                                 fontSize: '1.5rem',
//                                 fontWeight: 700,
//                                 color: '#1e293b',
//                                 formatter: function (val) {
//                                     return val + '%';
//                                 }
//                             },
//                             total: {
//                                 show: true,
//                                 showAlways: false,
//                                 label: 'Total',
//                                 fontSize: '0.875rem',
//                                 fontWeight: 600,
//                                 color: '#64748b',
//                                 formatter: function (w) {
//                                     return '100%';
//                                 }
//                             }
//                         }
//                     }
//                 }
//             },
//             stroke: {
//                 width: 0
//             },
//             dataLabels: {
//                 enabled: false
//             }
//         }
//     });

//     useEffect(() => {
//         fetchExpenseData();
//     }, [companyId]);

//     const fetchExpenseData = async () => {
//         try {
//             // Replace with actual API call
//             // const response = await axiosInstance.get(getApiUrl(`${companyId}/dashboard/expense-breakdown`));
//             // setChartData(response.data);
//         } catch (error) {
//             console.error('Error fetching expense data:', error);
//         }
//     };

//     return (
//         <div style={{ background: 'transparent' }}>
//             <ReactApexChart
//                 options={chartData.options}
//                 series={chartData.series}
//                 type="donut"
//                 height={280}
//             />
//         </div>
//     );
// };

// export default ExpenseChart;


// import React, { useState, useEffect } from 'react';
// import ReactApexChart from 'react-apexcharts';
// import { useParams } from 'react-router-dom';
// import axiosInstance from '../../../../services/AxiosInstance';
// import { getApiUrl } from '../../../../utils/ApiUtils';

// const ExpenseChart = () => {
//     const { companyId } = useParams();
//     const [chartData, setChartData] = useState({
//         series: [44, 25, 15, 10, 6],
//         options: {
//             chart: {
//                 type: 'donut',
//                 fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
//             },
//             labels: ['Löner', 'Hyra & Lokaler', 'Material', 'Marknadsföring', 'Övrigt'],
//             colors: ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#6b7280'],
//             responsive: [{
//                 breakpoint: 480,
//                 options: {
//                     chart: {
//                         width: 200
//                     },
//                     legend: {
//                         position: 'bottom'
//                     }
//                 }
//             }],
//             legend: {
//                 position: 'bottom',
//                 fontSize: '13px',
//                 fontWeight: 500,
//                 labels: {
//                     colors: '#374151'
//                 },
//                 markers: {
//                     width: 12,
//                     height: 12
//                 }
//             },
//             tooltip: {
//                 y: {
//                     formatter: function (val) {
//                         return val + '%';
//                     }
//                 },
//                 style: {
//                     fontSize: '12px',
//                     fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
//                 }
//             },
//             plotOptions: {
//                 pie: {
//                     donut: {
//                         size: '65%',
//                         labels: {
//                             show: true,
//                             name: {
//                                 show: true,
//                                 fontSize: '14px',
//                                 fontWeight: 600,
//                                 color: '#374151'
//                             },
//                             value: {
//                                 show: true,
//                                 fontSize: '20px',
//                                 fontWeight: 700,
//                                 color: '#1e293b',
//                                 formatter: function (val) {
//                                     return val + '%';
//                                 }
//                             },
//                             total: {
//                                 show: true,
//                                 showAlways: false,
//                                 label: 'Total',
//                                 fontSize: '14px',
//                                 fontWeight: 600,
//                                 color: '#64748b',
//                                 formatter: function (w) {
//                                     return '100%';
//                                 }
//                             }
//                         }
//                     }
//                 }
//             },
//             dataLabels: {
//                 enabled: false
//             },
//             stroke: {
//                 width: 0
//             }
//         }
//     });

//     useEffect(() => {
//         fetchExpenseData();
//     }, [companyId]);

//     const fetchExpenseData = async () => {
//         try {
//             // Replace with actual API call
//             // const response = await axiosInstance.get(getApiUrl(`${companyId}/dashboard/expense-breakdown`));
//             // setChartData(response.data);
//         } catch (error) {
//             console.error('Error fetching expense data:', error);
//         }
//     };

//     return (
//         <div>
//             <ReactApexChart
//                 options={chartData.options}
//                 series={chartData.series}
//                 type="donut"
//                 height={300}
//             />
//         </div>
//     );
// };

// export default ExpenseChart;